/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { ThumbsDownCheck } from './thumbsDownCheck';

export type GenericApiResponseThumbsDownCheckData = ThumbsDownCheck | null;
